/**
 * Гурван тайлангийн (захиалга, бараа, үлдэгдэл) хүсэлтэд нийтлэг дүрмүүд.
 *
 * Тайлагнасан гурван алдаа энд шийдэгдэнэ:
 *
 * 1. Огноо сонгоогүй/дутуу байхад «Хайх» шалгалтгүй ажилладаг байсан. Огноог
 *    цэвэрлээд дахин хайхад хүсэлт огноогүй явж, өмнөх үр дүн хэвээр үлддэг тул
 *    хэрэглэгчид «хуучин огноогоор хайлаа» мэт харагддаг байв.
 * 2. Өгөгдөл байхгүй үед ч Export нь «Excel файл амжилттай татагдлаа» гэдэг тул
 *    «Тайлан байхгүй байна»-тай зэрэг гарч, зөрчилтэй хоёр мэдэгдэл болдог байв.
 * 3. Алдаа гарахад ЭНД мэдэгдэл гаргавал давхардана — axios-ийн global
 *    interceptor (App.js) сервэрийн болон сүлжээний алдаа бүрд toast гаргадаг.
 *    Тиймээс алдааг зөвхөн бүртгэнэ.
 */

/** Нэг огноо сонгосон эсэх. Сонгоогүй бол шалтгааныг нь хэлнэ. */
export const findMissingDateError = (date) => (date ? null : 'Огноо сонгоно уу.');

/** Хугацааны мужийн хоёр тал бүрэн сонгосон эсэх */
export const findMissingRangeError = (range) =>
  range?.[0] && range?.[1] ? null : 'Эхлэх болон дуусах огноог бүрэн сонгоно уу.';

/**
 * Export-ын хариунаас татах холбоосыг гаргана.
 *
 * @returns {string|null} холбоос, эсвэл татах юм байхгүй бол `null`
 */
export const getExportUrl = (response) => response?.data?.result?.url || null;

/** Хөтчөөр файл татаж эхлүүлнэ */
export const startDownload = (url) => {
  const link = document.createElement('a');
  link.href = url;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
